













import { Vue, Component } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import UserModule from '@/store/userModule'
import TheNavbar from '@/components/layout/TheNavbar.vue'
import TheSidebar from '@/components/layout/TheSidebar.vue'

const userModule = getModule(UserModule)

@Component({
  components: {
    TheNavbar,
    TheSidebar
  }
})
export default class App extends Vue {
  private drawer: boolean | null = null

  get computedAuth() {
    return userModule.loggedIn
  }
}
